import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class SignInService {
    signInForm: FormGroup = new FormGroup({
        username: new FormControl({ value: '', disabled: false }, [Validators.required]),
        organization: new FormControl({ value: 'Hartford HealthCare', disabled: false }, [Validators.required])
    });
    serverErrorMessageModel = {
        id: 'ServerError',
        messageType: 'error',
        content: '',
        visible: false
    };

    clientErrorMessageModel = {
        id: 'ClientError',
        messageType: 'error',
        content: 'Review the form and correct highlighted fields.',
        visible: false
    };

    busy = false;
    advancedMode = false;
    serverError = this.serverErrorMessageModel;
    clientError = this.clientErrorMessageModel;
    username = '';
    organization = 'Hartford HealthCare';
    signInButtonText = this.advancedMode ? 'Generate Token' : 'Launch Encoder';
    signInHeaderText = this.advancedMode ? 'Create Token' : 'Enter Info';

    userNameDisabled = false;

    constructor() {}

    clearClientError() {
        this.serverError.visible = false;
        this.clientError.visible = false;
        this.signInForm.markAsPristine();
    }
}
